export const getPermissionsOfPages = (navMenu, currentPath) => {
    const findMatchingPermissions = (items) => {
        for (const item of items) {
            if (item.to === currentPath) {
                return {
                    insertAllowed: item.insertAllowed || 'N',
                    viewAllowed: item.viewAllowed || 'N',
                    updateAllowed: item.updateAllowed || 'N',
                    deleteAllowed: item.deleteAllowed || 'N'
                };
            }

            // if (item.items) {
            //     const result = findMatchingPermissions(item.items);
            //     if (result) return result;
            // }
        }
        return null;
    };

    return findMatchingPermissions(navMenu);
};
